import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export async function downloadReport(date, prefix = "beach_report") {
  try {
    const res = await api.get(`/report/export?date=${date}`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = `${prefix}_${date}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success(`Export ready — ${prefix}_${date}.xlsx`);
  } catch (err) {
    toast.error(apiError(err, "Export failed"));
  }
}
